jQuery(function($) {

    smiBlock.get();

    smiDfp.addBreakpoint('adhesion', 0, 480, false);
    smiDfp.addBreakpoint('phone', 0, 767, false);
    smiDfp.addBreakpoint('tablet', 768, 1023, false);
    smiDfp.addBreakpoint('desktop', 1024, 0, true);

    smiDfp.addGlobalTargeting('loggedin', cphGlobal.isSubscriber() ? 'true' : 'false');

    smiDfp.addKeywordSelector('.main-title');
    smiDfp.addKeywordSelector('.story-content');
    smiDfp.addKeyword('wildfire');
    smiDfp.addKeyword('firestorm');
    smiDfp.addKeyword('fires');
    smiDfp.addKeyword('cal fire');
    smiDfp.addKeyword('calfire');
    smiDfp.addKeyword('legal liability');
    smiDfp.addKeyword('disaster');
    smiDfp.addKeyword('lawsuit');

    var ad, wrap, shim, adDelay;

    ad = smiDfp.buildAd('tablet,desktop');
    ad.addTargeting('type', 'article');
    ad.addSize(1, 1);
    $('#one-by-one-ad').html(ad.render());

    ad = smiDfp.buildAd('phone,tablet,desktop');
    ad.addTargeting('type', 'teads');
    ad.addSize(2, 1);
    $('#one-by-one-ad').append(ad.render());

    wrap = smiDfp.buildAdWrapper();

    ad = smiDfp.buildAd('desktop');
    ad.addTargeting('position', 'ATF');
    ad.addTargeting('loc', '1');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);
    ad.addSize(970, 90);
    //ad.addSize(970, 250);
    ad.setForceReload();
    //ad.setNoReload();
    ad.wrapWith(wrap);

    ad = smiDfp.buildAd('tablet');
    ad.addTargeting('position', 'ATF');
    ad.addTargeting('loc', '1');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);
    ad.setForceReload();
    //ad.setNoReload();
    ad.wrapWith(wrap);

    $('#leaderboard-atf').html(wrap);

    var recipeLarge = $('#recipe-under-cover-ad-large'),
        recipeSmall = $('#recipe-under-cover-ad-small');

    if(recipeLarge.length) {
        wrap = smiDfp.buildAdWrapper();

        ad = smiDfp.buildAd('desktop');
        ad.addTargeting('position', 'ATF');
        ad.addTargeting('loc', '1');
        ad.addTargeting('type', 'article');
        ad.addSize(728, 90);
        ad.addSize(970, 90);
        ad.setDelay(500);
        ad.setForceReload();
        //ad.setNoReload();
        ad.wrapWith(wrap);

        ad = smiDfp.buildAd('tablet');
        ad.addTargeting('position', 'ATF');
        ad.addTargeting('loc', '1');
        ad.addTargeting('type', 'article');
        ad.addSize(728, 90);
        ad.setDelay(500);
        ad.setForceReload();
        //ad.setNoReload();
        ad.wrapWith(wrap);

        recipeLarge.html(wrap);
    }

    if(recipeSmall.length) {
        ad = smiDfp.buildAd('phone');
        ad.addTargeting('position', 'ATF');
        ad.addTargeting('loc', '1');
        ad.addTargeting('type', 'article');
        ad.addSize(320, 50);
        ad.setDelay(500);
        ad.setForceReload();
        //ad.setNoReload();

        recipeSmall.html(ad.render());
    }

    wrap = smiDfp.buildAdWrapper();

    ad = smiDfp.buildAd('desktop');
    ad.addTargeting('position', 'BTF');
    ad.addTargeting('loc', 'bottom');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);
    ad.addSize(970, 90);
    ad.addSize(970, 250);

    // switched these 2023-01-31
    ad.setShowOnScroll();
    //ad.setDelay(5000);

    ad.wrapWith(wrap);

    ad = smiDfp.buildAd('tablet');
    ad.addTargeting('position', 'BTF');
    ad.addTargeting('loc', 'bottom');
    ad.addTargeting('type', 'article');
    ad.addSize(728, 90);

    // switched these 2023-01-31
    ad.setShowOnScroll();
    //ad.setDelay(5000);

    ad.wrapWith(wrap);

    ad = smiDfp.buildAd('phone');
    ad.addTargeting('position', 'BTF');
    ad.addTargeting('loc', 'bottom');
    ad.addTargeting('type', 'article');
    ad.addSize(300, 250);

    // switched these 2023-01-31
    ad.setShowOnScroll();
    //ad.setDelay(5000);

    ad.wrapWith(wrap);

    $('#leaderboard-btf').html(wrap);


    wrap = smiDfp.buildAdWrapper('pw-adhesion-wrap');
    ad = smiDfp.buildAd('adhesion');
    ad.addSize(320, 50);
    ad.addSize(320, 100);
    ad.addTargeting('position', 'ATF');
    //ad.setNoReload(); // turned off 9/14/2022 per request from JdC
    ad.wrapWith(wrap);

    $("#adhesion-ad").html(wrap);


    shim = smiDfp.buildAdShim('adhesion', '50px');
    $('#adhesion-shim').html(shim);

    adDelay = 0;
    $('.page-break-ad').each(function(i) {
        adDelay = adDelay + 500;

        wrap = smiDfp.buildAdWrapper('widget-centered', 'text-align: center;');

        ad = smiDfp.buildAd('desktop');
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 2);
        ad.addTargeting('position', ((i + 2) >= 4) ? 'ATF' : 'BTF');
        ad.addSize(728, 90);
        ad.addSize(970, 90);
        ad.addSize(970, 250);

        // switched these 2023-01-31
        ad.setShowOnScroll();
        //ad.setDelay(adDelay);

        ad.wrapWith(wrap);

        ad = smiDfp.buildAd('tablet');
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 2);
        ad.addTargeting('position', ((i + 2) >= 4) ? 'ATF' : 'BTF');
        ad.addSize(728, 90);

        // switched these 2023-01-31
        ad.setShowOnScroll();
        //ad.setDelay(adDelay);

        ad.wrapWith(wrap);

        ad = smiDfp.buildAd('phone');
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 2);
        ad.addTargeting('position', ((i + 2) >= 4) ? 'ATF' : 'BTF');
        ad.addSize(300, 250);

        // switched these 2023-01-31
        ad.setShowOnScroll();
        //ad.setDelay(adDelay);

        ad.wrapWith(wrap);

        $(this).html(wrap);
    });

    let sbAdDelay = 0;
    let sbCubeLoc = 0
    let sbHalfLoc = 0
    let sbHouseLoc = 0
    $('.sidebar-cube-ad, .sidebar-half-ad, .sidebar-house-ad').each(function(i) {
        var cube = $(this),
            dataClass = cube.data('class'),
            dataTargeting = cube.data('targeting'),
            adClass = null,
            adLoc, adSize;

        sbAdDelay += 100;

        if(cube.hasClass('sidebar-half-ad')) {
            adSize = [300, 600];
            adLoc = ++sbHouseLoc;
        } else if(cube.hasClass('sidebar-house-ad')) {
            adSize = [300, 100];
            adLoc = ++sbHalfLoc;
        } else {
            adSize = [300, 250];
            adLoc = ++sbCubeLoc;
        }

        if(dataClass && dataClass !== 'undefined') {
            adClass = dataClass;
        }

        ad = smiDfp.buildAd('desktop', adClass);
        ad.addSize(adSize[0], adSize[1]);
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', adLoc);

        // switched these 2023-01-31
        ad.setShowOnScroll();
        //ad.setDelay(sbAdDelay);

        if(dataTargeting && dataTargeting !== 'undefined') {
            $.each(dataTargeting, function(key, value) {
                ad.addTargeting(key, value);
            });
        }

        $(this).html(ad.render());
    });

    adDelay = 500;
    $('.article-inline-ad').each(function(i) {
        var cube = $(this),
            dataClass = cube.data('class'),
            dataTargeting = cube.data('targeting'),
            adClass = null;

        adDelay = adDelay + 500;

        if(dataClass && dataClass !== 'undefined') {
            adClass = dataClass;
        }

        wrap = smiDfp.buildAdWrapper('widget-centered', 'height: 250px; width: 300px; background-color: #F0F0F0; box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.3);');

        ad = smiDfp.buildAd('phone,tablet,desktop', adClass);
        ad.addSize(300, 250);
        ad.addTargeting('type', 'article');
        ad.addTargeting('loc', i + 1);

        // switched these 2023-01-31
        ad.setShowOnScroll();
        //ad.setDelay(adDelay);

        if(i === 0) { // do not reload first, mobile-only ad
            ad.setNoReload();
        }

        if(dataTargeting && dataTargeting !== 'undefined') {
            $.each(dataTargeting, function(key, value) {
                ad.addTargeting(key, value);
            });
        }
        ad.wrapWith(wrap);

        $(this).html(wrap);
    });

    smiDfp.loadAds();
});
jQuery(function($) {
    const shareUuid = window.articleUuid;
    const apiBase = cphGlobal.isStage() ? 'https://cph.pressdemocrat.com/_api.pressdemocrat.com' : 'https://api.pressdemocrat.com';

    (function() {
        const getArticlesVerified = function() {
            return JSON.parse(localStorage.getItem('articlesVerified') || '[]');
        };

        const addArticleVerified = function(hash) {
            let articlesVerified = getArticlesVerified();
            articlesVerified.push({
                hash: hash,
                uuid: shareUuid
            });
            localStorage.setItem('articlesVerified', JSON.stringify(articlesVerified));
        };

        const isArticleVerified = function(hash) {
            let articlesVerified = getArticlesVerified().filter(function(articleVerified) {
                return articleVerified.hash === hash && articleVerified.uuid === shareUuid;
            });
            return !!articlesVerified.length;
        };

        const applyGiftAccess = function() {
            // If Connext has not already run, this should update it before it does
            $(document).off('onInit.applyGift');
            $(document).on('onInit.applyGift', function() {
                window.mg2PageData.metered = 0;
                window.mg2PageData.thick = 0;
                window.mg2PageData.premium = 0;
                window.mg2PageData.gifted = 1;
            });

            // If Connext has already run, this should run it again with updates
            if(window.Connext) {
                window.mg2PageData.metered = 0;
                window.mg2PageData.thick = 0;
                window.mg2PageData.premium = 0;
                window.mg2PageData.gifted = 1;

                Connext.Run('Gifted article');
                $(document).trigger('removePaywallBlur');
            }
        };

        const verifyArticleShare = function(hash) {
            if(isArticleVerified(hash)) {
                applyGiftAccess();
                return;
            }

            $.post(apiBase + '/subscriber/verify-article-share.php', {
                hash: hash
            }).done(function(data) {
                let uuid = data['article_uuid'] || '';
                if(uuid === shareUuid) {
                    applyGiftAccess();
                    addArticleVerified(hash);
                }
            });
        };

        const acBase64 = cphGlobal.getQueryStringValueByKey('ac');
        if(acBase64) {
            const ac = window.atob(decodeURIComponent(acBase64));
            if(ac === 'article-share') {
                const hash = cphGlobal.getQueryStringValueByKey('ah');
                verifyArticleShare(hash);
            }
        }
    })();

    const as = window.articleShare;
    if(!as || !as.slugs) return;

    function articleShareBuilder(config, utmSource, utmCampaign) {
        if(!config || !config.slugs || !config.slugs.length) return;

        const articleShare = {
            config       : config,
            utmSource    : utmSource,
            utmCampaign  : utmCampaign,
            queryParams  : [],
            emailSubject : null,
            emailBody    : null,
            onLinkClick  : null,
            onCopySuccess: null,
            onCopyFail   : null
        };

        articleShare.setUtmSource = function(utmSource) {
            articleShare.utmSource = utmSource;
        };

        articleShare.setUtmCampaign = function(utmCampaign) {
            articleShare.utmCampaign = utmCampaign;
        };

        articleShare.addQueryParam = function(key, value) {
            articleShare.queryParams.push({
                key  : key,
                value: value
            });
        };

        articleShare.setEmailSubject = function(emailSubject) {
            articleShare.emailSubject = emailSubject;
        };

        articleShare.setEmailBody = function(emailBody) {
            articleShare.emailBody = emailBody;
        };

        articleShare.setOnLinkClick = function(onLinkClick) {
            articleShare.onLinkClick = onLinkClick;
        };

        articleShare.setOnCopySuccess = function(onCopySuccess) {
            articleShare.onCopySuccess = onCopySuccess;
        };

        articleShare.setOnCopyFail = function(onCopyFail) {
            articleShare.onCopyFail = onCopyFail;
        };

        articleShare.updateItemText = function(el, newText, color, revertAfter) {
            const isUpdated = !!el.data('has-updated-text');
            if(isUpdated) return;

            revertAfter = revertAfter || 3500;
            el.data('has-updated-text', true);

            const textContainer = el.find('.article-share__text');
            const prevHtml = textContainer.html();

            textContainer.text(newText).css('color', color);
            setTimeout(function() {
                el.data('has-updated-text', false);
                textContainer.html(prevHtml).css('color', '');
            }, revertAfter);
        };

        const _buildItem = function(slug) {
            const item = {
                slug       : slug,
                name       : null,
                adaText    : null,
                faIconClass: null,
                color      : null,
                href       : null,
                hrefTarget : '_blank'
            };
            switch(slug) {
                case 'copy-link' :
                    item.name = 'Copy link';
                    item.adaText = 'copy link to story';
                    item.faIconClass = 'fa fa-link';
                    item.color = '#333333';
                    item.hrefTarget = '_self';
                    break;
                case 'email' :
                    item.name = 'Email';
                    item.adaText = 'email this article';
                    item.faIconClass = 'fa fa-envelope';
                    item.color = '#585858';
                    item.href = 'mailto:?subject={{subject}}&body={{body}}';
                    item.hrefTarget = '_self';
                    break;
                case 'facebook' :
                    item.name = 'Facebook';
                    item.adaText = 'share on facebook';
                    item.faIconClass = 'fa fa-facebook';
                    item.color = '#3B5998';
                    item.href = 'https://www.facebook.com/sharer/sharer.php?u={{permalink}}&t={{headline}}';
                    break;
                case 'twitter' :
                    item.name = 'Twitter';
                    item.adaText = 'share on twitter';
                    item.faIconClass = 'fa fa-twitter';
                    item.color = '#1DA1F2';
                    item.href = 'https://twitter.com/intent/tweet?text={{headline}}&url={{permalink}}';
                    break;
                case 'linkedin' :
                    item.name = 'LinkedIn';
                    item.adaText = 'share on linkedin';
                    item.faIconClass = 'fa fa-linkedin';
                    item.color = '#0A66C2';
                    item.href = 'https://www.linkedin.com/sharing/share-offsite?mini=true&ro=false&summary=&source=&url={{permalink}}&title={{headline}}';
                    break;
                case 'reddit' :
                    item.name = 'Reddit';
                    item.adaText = 'share on reddit';
                    item.faIconClass = 'fa fa-reddit-alien';
                    item.color = '#FF5700';
                    item.href = 'https://www.reddit.com/submit?url={{permalink}}&title={{headline}}';
                    break;
                case 'pinterest' :
                    item.name = 'Pinterest';
                    item.adaText = 'share on pinterest';
                    item.faIconClass = 'fa fa-pinterest-p';
                    item.color = '#BD081C';
                    item.href = 'https://www.pinterest.com/pin/create/bookmarklet/?url={{permalink}}&media={{imageUrl}}&description={{headline}}';
                    break;
                case 'print' :
                    item.name = 'Print';
                    item.adaText = 'print this article';
                    item.faIconClass = 'fa fa-print';
                    item.color = '#738A8D';
                    item.hrefTarget = '_self';
                    break;
            }

            item.exists = item.name && item.adaText && item.faIconClass && item.color;

            return item;
        };

        const _buildItemHtml = function(item) {
            if(!item.exists) return;

            return $('<a/>', {
                target        : item.hrefTarget,
                class         : 'article-share__item article-share__item--' + item.slug,
                href          : 'javascript:void(0);',
                style         : '--article-share-color: ' + item.color,
                'data-network': item.name,
                'data-color'  : item.color,
                'data-href'   : item.href,
                html          : [
                    '<i class="article-share__icon ' + item.faIconClass + '" aria-hidden="true"></i>',
                    '<span class="article-share__text" aria-hidden="true">' + item.name + '</span>',
                    '<span class="visually-hidden">' + item.adaText + '</span>'
                ]
            }).data('item', item);
        };

        const _doCopyLinkClick = function(clicked, articleHref) {
            cphGlobal.copyTextToClipboard(articleHref, function() {
                articleShare.updateItemText(clicked, 'Copied', 'green');
                if(typeof articleShare.onCopySuccess === 'function')
                    articleShare.onCopySuccess.call(articleShare, clicked, articleHref);
            }, function() {
                articleShare.updateItemText(clicked, 'Failed', 'red');
                if(typeof articleShare.onCopyFail === 'function')
                    articleShare.onCopyFail.call(articleShare, clicked, articleHref);
            });
        };

        articleShare.doLinkClick = function(clicked, articleHref) {
            const item = clicked.data('item') || {};

            if(item.slug === 'copy-link') {
                _doCopyLinkClick(clicked, articleHref);
                return false;
            }

            if(item.slug === 'print') {
                window.print();
                return false;
            }

            let redirectHref = item.href;
            if(!redirectHref) return false;

            if(item.slug === 'email') {
                redirectHref = redirectHref.replaceAll('{{subject}}', encodeURIComponent(articleShare.emailSubject));
                redirectHref = redirectHref.replaceAll('{{body}}', encodeURIComponent(articleShare.emailBody));

                redirectHref = redirectHref.replaceAll('%7B%7Bheadline%7D%7D', '{{headline}}');
                redirectHref = redirectHref.replaceAll('%7B%7Bpermalink%7D%7D', '{{permalink}}');
                redirectHref = redirectHref.replaceAll('%7B%7BimageUrl%7D%7D', '{{imageUrl}}');
            }

            redirectHref = redirectHref.replaceAll('{{headline}}', encodeURIComponent(articleShare.config.headline));
            redirectHref = redirectHref.replaceAll('{{permalink}}', encodeURIComponent(articleHref));
            redirectHref = redirectHref.replaceAll('{{imageUrl}}', encodeURIComponent(articleShare.config.imageUrl));

            clicked.attr('href', redirectHref);

            if(item.hrefTarget === '_self') {
                window.location.href = redirectHref;
                return;
            }

            window.open(redirectHref);
        };

        articleShare.render = function() {
            const menu = $('<ul/>', {
                style: 'min-width: 140px;',
                class: 'share-icons__article-share-menu'
            });

            let linkBase = articleShare.config.permalink;

            Object.values(articleShare.queryParams || {}).forEach(function(param) {
                linkBase = cphGlobal.updateQueryStringParameter(param.key, param.value, linkBase);
            });

            if(articleShare.utmSource) {
                linkBase = cphGlobal.updateQueryStringParameter('utm_source', articleShare.utmSource, linkBase);
            }

            if(articleShare.utmCampaign) {
                linkBase = cphGlobal.updateQueryStringParameter('utm_campaign', articleShare.utmCampaign, linkBase);
            }

            Object.values(articleShare.config.slugs || {}).forEach(function(slug) {
                const item = _buildItem(slug);
                if(!item.exists) return;

                if(item.slug === 'pinterest' && !articleShare.config.imageUrl) return;
                if(item.slug === 'email' && !(articleShare.emailSubject && articleShare.emailBody)) return;

                let itemHtml = _buildItemHtml(item);
                if(!itemHtml) return;

                $('<li/>', {
                    html: itemHtml
                }).appendTo(menu);

                const articleHref = cphGlobal.updateQueryStringParameter('utm_medium', encodeURIComponent(item.slug), linkBase);

                itemHtml.on('click.articleShare', function(e) {
                    e.preventDefault();

                    const clicked = $(this);
                    if(typeof articleShare.onLinkClick === 'function') {
                        articleShare.onLinkClick.call(articleShare, clicked, articleHref);
                        return;
                    }
                    articleShare.doLinkClick(clicked, articleHref);
                });
            });

            return menu;
        };

        return articleShare;
    }

    function articleShareTooltip(button, title, html) {
        if(!button.length) return;
        cphLoader.loadTipped(function() {
            Tipped.create(button[0], html[0], {
                container : $('#page-wrap')[0],
                title     : title,
                close     : true,
                showOn    : 'click',
                hideOn    : false,
                position  : 'bottomright',
                skin      : 'light',
                size      : 'large',
                maxWidth  : 200,
                radius    : false,
                hideOthers: true,
                voila     : false,
                zIndex    : 9
                /*onShow    : function(content, element) {
                    console.log('AS: show', content, element);
                    $(content).html(html.html());
                },
                afterHide : function(content, element) {
                    console.log('AS: hide', content, element);
                    //Tipped.remove(element);
                }*/
            })/*.show()*/;
            //Tipped.hide(button[0]);
        });
    }



    const shareContainer = $('#article-share');
    if(shareContainer.length) {
        const shareButton = $('<button/>', {
            html: '<i class="fa fa-share" aria-hidden="true"></i>'
        });

        shareContainer.html(shareButton);

        const articleShare = articleShareBuilder(as, 'article_share');
        articleShare.setEmailSubject('A ' + cphPubName + ' article has been shared with you');
        articleShare.setEmailBody('A ' + cphPubName + ' reader has shared the following article with you.\n\n{{headline}}\n\n{{permalink}}');

        const shareContent = $('<div/>');

        if(cphGlobal.pageIsMetered() || cphGlobal.pageIsGifted())
            shareContent.html('<p>Share a link which will be subject to our paywall.</p>');

        shareContent.append(articleShare.render());

        articleShareTooltip(shareButton, 'Share this article', shareContent);
    }


    // no gifting if not on pd, sit, pac or nbbj
    if(!(cphPD || cphSIT || cphPAC || cphNBBJ)) return;

    // gift article relies on sessionStorage & localStorage, so don't show if unavailable
    if(!cphGlobal.hasSessionStorage() || !cphGlobal.hasLocalStorage()) return;

    // no gifting if page is not metered or gifted
    if(!(cphGlobal.pageIsMetered() || cphGlobal.pageIsGifted())) return;

    // no gifting if nowhere to add button
    const giftContainer = $('#article-gift');
    if(!giftContainer.length) return;

    const setSession = function(account, articles) {
        articles = (articles || []).filter(function(uuid, i) {
            return articles.indexOf(uuid) === i;
        });

        sessionStorage.setItem('articleShare', JSON.stringify({
            account : account || {},
            articles: articles
        }));
    };

    const clearSession = function() {
        sessionStorage.removeItem('articleShare');
    };

    const getUserAccount = function() {
        let session = JSON.parse(sessionStorage.getItem('articleShare') || '{}');
        return session.account || {};
    };

    const getArticlesShared = function() {
        let session = JSON.parse(sessionStorage.getItem('articleShare') || '{}');
        return session.articles || [];
    };

    const addArticleShared = function(articleUuid) {
        let account = getUserAccount(),
            articles = getArticlesShared();
        articles.push(articleUuid);
        setSession(account, articles);
    };

    const decrementSharedCount = function() {
        let span = $('#gift-this-count-remaining');
        if(span.data('decremented')) return;

        let count = parseInt(span.text());
        if(count > 0) span.text(--count).data('decremented', true);

        addArticleShared(shareUuid);
    };

    const sendShareRequest = function(userHash) {
        return $.post(apiBase + '/subscriber/track-article-share.php', {
            hash: userHash,
            uuid: shareUuid
        });
    };

    const doGiftButton = function() {
        cphLoader.loadTipped(function() {
            const button = giftContainer.find('button').first();
            if(button.length) Tipped.remove(button[0]);
        });

        const ag = as;
        ag.slugs = ag.slugs.filter(function(slug) {
            return slug !== 'print';
        });

        const giftButton = $('<button/>', {
            class: 'no-wrap',
            html : '<i class="ms ms-gift" aria-hidden="true"></i><span class="visually-hidden">Gift this article</span>'
        });

        giftContainer.html(giftButton);

        const giftContent = $('<div class="gift-this"/>');
        const account = getUserAccount();
        const accountHash = account.hash || null;
        const isSubscriber = !!account['is_subscriber'];

        if(!isSubscriber) {
            giftContent.html(
                '<p><em style="color: #666666;">For subscribers only:</em></p>' +
                '<p><strong>This premium feature allows you to gift up to 10 articles every 30 days.</strong></p>' +
                '<p class="gift-this__subscribe-button"><a href="' + window.siteConfig.url.subscribe + '">Subscribe</a></p>' +
                '<p class="gift-this__links">Already a subscriber? ' +
                '<a class="hide-logged-in" href="javascript:void(0);" data-mg2-action="login">Log In</a>' +
                '<span class="hide-logged-in"> or </span>' +
                '<a class="" href="javascript:void(0);" data-mg2-action="activation">Link Your Account</a>' +
                '</p>'
            );

            articleShareTooltip(giftButton, 'Gift this article', giftContent);
            return;
        }

        const sharedArticles = getArticlesShared();
        const shareCount = sharedArticles.length;
        const alreadyShared = sharedArticles.indexOf(shareUuid) !== -1;
        const maxShares = isSubscriber ? 10 : 0;
        const isShareable = alreadyShared || shareCount < maxShares;

        if(!isShareable) {
            giftContent.html('<p><strong>You have reached your limit of ' + maxShares + ' gifted articles in a 30 day period.</strong></p>');
            articleShareTooltip(giftButton, 'Gift this article', giftContent);
            return;
        }

        let remaining = $('<span/>', {
            id  : 'gift-this-count-remaining',
            text: (maxShares - shareCount)
        }).data('decremented', alreadyShared);

        let remainingOf = $('<strong/>', {
            class: 'float-right',
            html : [remaining, '/', maxShares]
        });

        let html = [remainingOf, '<p><em style="color: #666666;">Benefit remaining:</em></p>'];
        if(alreadyShared) {
            html.push('<p>You’ve gifted this article before — thanks. Gift it again and it will not count against your limit.</p>');
        } else {
            html.push('<p>Gift this article to a friend, paywall-free.</p>');
        }

        giftContent.html(html);

        const articleGift = articleShareBuilder(ag, 'article_gift');
        articleGift.setEmailSubject('A ' + cphPubName + ' article has been shared with you');
        articleGift.setEmailBody('A ' + cphPubName + (isSubscriber ? ' subscriber ' : ' reader ') + 'has shared the following article with you.\n\nYou have full access to it — no paywall! Just click on the link to start reading.\n\n{{headline}}\n\n{{permalink}}');

        articleGift.setOnLinkClick(function(clicked, articleHref) {
            let xhr = sendShareRequest(accountHash);
            xhr.done(function(data) {
                data = data || {};

                articleHref = cphGlobal.updateQueryStringParameter('ac', window.btoa(encodeURIComponent('article-share')), articleHref);
                articleHref = cphGlobal.updateQueryStringParameter('ah', data.hash, articleHref);
                articleGift.doLinkClick(clicked, articleHref);

                decrementSharedCount();
            });

            xhr.fail(function() {
                articleGift.updateItemText(clicked, 'Failed', 'red');
            });
        });

        giftContent.append(articleGift.render());
        articleShareTooltip(giftButton, 'Gift this article', giftContent);
    };

    const fetchAccount = function(engageUserData) {
        if(typeof engageUserData !== 'object') return;

        let pub = cphPubAbbrev,
            uid = engageUserData.MasterId || '',
            em = engageUserData.Email || '',
            sub = engageUserData.DigitalAccess.IsAuthorized ? 1 : 0;

        if(!(pub && uid && em)) return;

        let request = $.get(apiBase + '/subscriber/get.php', {
            pub: pub,
            uid: uid,
            em : em,
            sub: sub
        });

        request.done(function(data) {
            let account = data.account || {},
                shareData = data.share || {},
                articles = shareData.articles || [];

            setSession(account, articles);
            doGiftButton();
        });

        request.fail(function() {
            clearSession();
        });
    };

    doGiftButton();
    $(document).on('mg2:notSubscribed mg2:loggedOut', function(e) {
        clearSession();
        doGiftButton();
    });

    $(document).on('mg2:subscribed mg2:notSubscribed', function(e, data) {
        if(cphGlobal.pageIsMetered() || cphGlobal.pageIsGifted()) {
            data = data || {};
            fetchAccount(data.userData);
        }
    });
});



jQuery(function($) {
    // gift article relies on sessionStorage & localStorage, so don't show if unavailable
    if(!cphGlobal.hasSessionStorage() || !cphGlobal.hasLocalStorage()) return;

    const giftContainer = $('#gift-this-article');
    const maxShares = 10;
    const shareUuid = window.articleUuid;

    const apiBase = cphGlobal.isStage() ? 'https://cph.pressdemocrat.com/_api.pressdemocrat.com' : 'https://api.pressdemocrat.com';

    if(!giftContainer.length) return;

    let utf8ToBase64 = function(string) {
        if(!string) return '';
        return window.btoa(encodeURIComponent(string));
    };

    let setSession = function(account, articles) {
        articles = (articles || []).filter(function(uuid, i) {
            return articles.indexOf(uuid) === i;
        });

        sessionStorage.setItem('articleShare', JSON.stringify({
            account : account || {},
            articles: articles
        }));
    };

    let clearSession = function() {
        sessionStorage.removeItem('articleShare');
    };

    let getUserAccount = function() {
        let session = JSON.parse(sessionStorage.getItem('articleShare') || '{}');
        return session.account || {};
    };

    let getArticlesShared = function() {
        let session = JSON.parse(sessionStorage.getItem('articleShare') || '{}');
        return session.articles || [];
    };

    let addArticleShared = function(articleUuid) {
        let account = getUserAccount(),
            articles = getArticlesShared();
        articles.push(articleUuid);
        setSession(account, articles);
    };

    let buildLink = function(utmMedium, articleShareHash) {
        let link = location.protocol + '//' + location.host + location.pathname,
            query = [];

        query.push('utm_source=marketing');
        query.push('utm_medium=' + utmMedium);
        query.push('utm_campaign=article-share');

        if(articleShareHash) {
            query.push('ac=' + utf8ToBase64('article-share'));
            query.push('ah=' + articleShareHash);
        }

        return link + '?' + query.join('&');
    };

    let emailLink = function(articleShareHash) {
        let title = document.title,
            pubName = cphPubName || 'Press Democrat',
            subject, body;

        subject = 'A ' + pubName + ' article has been shared with you';

        if(articleShareHash) {
            body = 'A ' + pubName + ' subscriber has shared the following article with you.\n\n';
            body += 'You have full access to it — no paywall! Just click on the link to start reading.\n\n';
            body += title + '\n\n' + buildLink('email-sub', articleShareHash);
        } else {
            body = 'A ' + pubName + ' reader has shared the following article with you.\n\n';
            //body += 'Just click on the link to start reading.\n\n';
            body += title + '\n\n' + buildLink('email');
        }
        return 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    };

    let sendShareRequest = function(userHash) {
        return $.post(apiBase + '/subscriber/track-article-share.php', {
            hash: userHash,
            uuid: shareUuid
        });
    };

    let buildTooltip = function(type, button) {
        let account = getUserAccount(),
            accountHash = account.hash || '',
            isSubscriber = account['is_subscriber'] || false,
            sharedArticles = getArticlesShared(),
            shareCount = sharedArticles.length,
            alreadyShared = sharedArticles.indexOf(shareUuid) !== -1,
            isShareable = alreadyShared || shareCount < maxShares,
            isShareOnly = type === 'share',
            content = $('<div class="gift-this"/>'),
            title = 'Share this article';

        if(isShareOnly || (isSubscriber && accountHash)) {
            let emailButtonText = $('<span class="gift-this__email-button-text">Email</span>');

            let emailButton = $('<button/>', {
                html: [
                    '<i class="fa fa-fw fa-envelope-o m1-r" aria-hidden="true"></i>',
                    emailButtonText
                ]
            });

            let copyButtonText = $('<span class="gift-this__copy-button-text">Copy Link</span>');

            let copyButton = $('<button/>', {
                html: [
                    '<i class="fa fa-fw fa-link m1-r" aria-hidden="true"></i>',
                    copyButtonText
                ]
            });

            if(!isShareOnly && accountHash) {
                title = 'Gift this article';

                if(isShareable) {
                    let remaining = $('<span/>', {
                        id  : 'gift-this-count-remaining',
                        text: (maxShares - shareCount)
                    }).data('decremented', alreadyShared);

                    let remainingOf = $('<strong/>', {
                        class: 'float-right',
                        html : [remaining, '/', maxShares]
                    });

                    let html = [remainingOf, '<p><em style="color: #666666;">Benefit remaining:</em></p>'];
                    if(alreadyShared) {
                        html.push('<p>You’ve gifted this article before — thanks. Gift it again and it will not count against your limit.</p>');
                    } else {
                        html.push('<p>Gift this article to a friend, paywall-free.</p>');
                    }

                    content.html(html);
                } else {
                    content.html([
                        '<p><strong>You have reached your limit of ' + maxShares + ' gifted articles in a 30 day period.</strong></p>',
                        '<p>You can still share this article, but the links will not be paywall-free.</p>'
                    ]);
                }
            }

            let buttons = $('<div class="gift-this__buttons"/>');
            buttons.html([emailButton, '<hr>', copyButton]);
            content.append(buttons);

            let doEmailButtonClickFailed = function(text) {
                let startText = emailButtonText.text();

                text = text || 'Failed';

                emailButton.css('color', 'red');
                emailButtonText.text(text);

                setTimeout(function() {
                    emailButton.css('color', '');
                    emailButtonText.text(startText);
                }, 3500);
            };

            let doEmailButtonClick = function(articleShareHash) {
                let link;

                if(articleShareHash && isShareable) {
                    link = emailLink(articleShareHash);
                } else {
                    link = emailLink();
                }

                window.location.href = link;
            };

            let doCopyButtonClickFailed = function(text) {
                let startText = copyButtonText.text();

                text = text || 'Failed';

                copyButton.css('color', 'red');
                copyButtonText.text(text);

                setTimeout(function() {
                    copyButton.css('color', '');
                    copyButtonText.text(startText);
                }, 3500);
            };

            let doCopyButtonClick = function(articleShareHash) {
                let startText = copyButtonText.text(),
                    link;

                if(articleShareHash) {
                    link = buildLink('copy-link-sub', articleShareHash);
                } else {
                    link = buildLink('copy-link');
                }

                cphGlobal.copyTextToClipboard(link, function() {
                    copyButton.css('color', 'green');
                    copyButtonText.text('Copied');

                    setTimeout(function() {
                        copyButton.css('color', '');
                        copyButtonText.text(startText);
                    }, 3500);
                }, function() {
                    doCopyButtonClickFailed();
                });
            };

            let decrementSharedCount = function() {
                let span = $('#gift-this-count-remaining');
                if(span.data('decremented')) return;

                let count = parseInt(span.text());
                if(count > 0) span.text(--count).data('decremented', true);

                addArticleShared(shareUuid);
            };

            emailButton.off('click');
            emailButton.on('click', function() {
                if(!isShareOnly && accountHash && isShareable) {
                    let xhr = sendShareRequest(accountHash);

                    xhr.done(function(data) {
                        data = data || {};
                        doEmailButtonClick(data.hash);
                        decrementSharedCount();
                    });

                    xhr.fail(function() {
                        doEmailButtonClickFailed();
                    });

                    return;
                }

                doEmailButtonClick();
            });

            copyButton.off('click');
            copyButton.on('click', function() {
                if(!isShareOnly && accountHash && isShareable) {
                    let xhr = sendShareRequest(accountHash);

                    xhr.done(function(data) {
                        data = data || {};
                        doCopyButtonClick(data.hash);
                        decrementSharedCount();
                    });

                    xhr.fail(function() {
                        doCopyButtonClickFailed();
                    });

                    return;
                }

                doCopyButtonClick();
            });
        }

        if(content.is(':empty')) {
            content = $('<div class="gift-this">' +
                '<p><em style="color: #666666;">For subscribers only:</em></p>' +
                '<p><strong>This premium feature allows you to gift up to 10 articles every 30 days.</strong></p>' +
                '<p class="gift-this__subscribe-button"><a href="' + siteConfig.url.subscribe + '">Subscribe</a></p>' +
                '<p class="gift-this__links">Already a subscriber? ' +
                '<a href="javascript:void(0);" data-mg2-action="login">Log In</a> or ' +
                '<a href="javascript:void(0);" data-mg2-action="activation">Link Your Account</a>' +
                '</p>' +
                '</div>');
        }

        Tipped.create(button, content[0], {
            container : $('#page-wrap')[0],
            title     : title,
            close     : true,
            showOn    : 'click',
            hideOn    : false,
            position  : 'bottomleft',
            maxWidth  : 180,
            skin      : 'light',
            size      : 'large',
            radius    : false,
            hideOthers: true,
            voila     : false,
            zIndex    : 9
        }).show();
    };

    let prepareTipped = function(callback) {
        cphLoader.loadTipped(function() {
            let button = giftContainer.find('> button');
            if(button.length) Tipped.hide(button[0]);
            callback.call();
        });
    };

    let giftArticle = function() {
        prepareTipped(function() {
            let button = $('<button/>', {
                class: 'no-wrap',
                html : '<i class="ms ms-gift" aria-hidden="true"></i> Gift this article <span class="hide-m">to a friend</span>'
            });
            giftContainer.html(button);
            button.on('click', function() {
                buildTooltip('gift', button);
            });
        });
    };

    let shareArticle = function() {
        prepareTipped(function() {
            let button = $('<button/>', {
                html: '<i class="ms ms-share" aria-hidden="true"></i> Share this article'
            });
            giftContainer.html(button);
            button.on('click', function() {
                buildTooltip('share', button);
            });
        });
    };

    let giftOrShareArticle = function() {
        if(!(cphPD || cphSIT || cphPAC)) {
            shareArticle();
            return;
        }
        if(cphGlobal.pageIsMetered() || cphGlobal.pageIsGifted()) {
            giftArticle();
            return;
        }

        shareArticle();
    };

    let fetchAccount = function(engageUserData) {
        if(typeof engageUserData !== 'object')
            return;

        let pub = cphPubAbbrev,
            uid = engageUserData.MasterId || '',
            em = engageUserData.Email || '',
            sub = engageUserData.DigitalAccess.IsAuthorized ? 1 : 0;

        if(!(pub && uid && em)) return;

        let request = $.get(apiBase + '/subscriber/get.php', {
            pub: pub,
            uid: uid,
            em : em,
            sub: sub
        });

        request.done(function(data) {
            let account = data.account || {},
                shareData = data.share || {},
                articles = shareData.articles || [];

            setSession(account, articles);
            giftOrShareArticle();
        });

        request.fail(function() {
            clearSession();
        });
    };

    giftOrShareArticle();
    $(document).on('mg2:notSubscribed mg2:loggedOut', function() {
        clearSession();
        giftOrShareArticle();
    });

    $(document).on('mg2:subscribed mg2:notSubscribed', function(e, data) {
        if(cphGlobal.pageIsMetered() || cphGlobal.pageIsGifted()) {
            data = data || {};
            fetchAccount(data.userData);
        }
    });
});
// INSERT BEG INTO PREDEFINED DIV AFTER EACH STORY
/*if(cphPD) {
    jQuery(function($) {
        if(typeof pageTags !== 'object')
            return;

        if(pageTags.indexOf('2022_general_election') === -1)
            return;

        var afterStory = $('#beg-container'),
            isSubscribed = cphGlobal.isSubscriber(),
            isOverridden = cphGlobal.getQueryStringValueByKey('showBeg') === 'pleez';

        if(!isOverridden && isSubscribed)
            return false;

        if(afterStory.length) {

            //if(isOverridden || document.referrer.match(/google|bing|facebook|twitter|instagram|pinterest/)) {
            $(window).on('resize.showAfterStory scroll.showAfterStory', $.throttle(200, function() {
                if(afterStory.isInViewport()) {
                    $(window).off('.showAfterStory');

                    var fetch = $.get('https://code.pressdemocrat.com/shared/after-article/election-20221109.html');

                    fetch.done(function(data) {
                        afterStory.html(data);
                        cphGlobal.replaceUrl(cphGlobal.updateQueryStringParameter('sba', 'AAS'));
                    }, 'html');
                }
            }));
            //}
        }
    });
}*/

// BIG STORY COVER IMAGE
jQuery(function($) {
    if($('.big-story .article-container').length) {
        var coverImage = $('#bs-cover-photo'),
            scrollDown = $('#bs-scroll-down'),
            scrollIcon = scrollDown.find('.bs-scroll-icon');

        if(coverImage.length) {
            var wHeight = $(window).outerHeight(),
                wWidth = $(window).outerWidth(),
                topper = $('#page-topper'),
                hHeight = topper.outerHeight();

            var loadAndResizeUpdates = function() {
                if(wWidth > wHeight) {
                    coverImage.css({paddingBottom: (wHeight - hHeight) + 'px'}).addClass('fixed');
                    scrollDown.addClass('show');
                } else {
                    coverImage.css({paddingBottom: '65%'}).removeClass('fixed');
                    scrollDown.removeClass('show');
                }
            };

            loadAndResizeUpdates();

            cphLoader.loadThrottleDebounce(function() {
                $(window).on('resize', $.debounce(250, function() {
                    wHeight = $(window).outerHeight();
                    wWidth = $(window).outerWidth();
                    loadAndResizeUpdates();
                }));
            });

            scrollIcon.on('click', function() {
                $('html, body').animate({scrollTop: (coverImage.outerHeight() + coverImage.offset().top)}, 750);
            });
        }
    }
});
jQuery(function($) {
    $('.feature-recipe').each(function() {
        var body = $(document.body),
            recipe = $(this),
            firstChild = recipe.find('>:first-child'),
            ingredients = recipe.find('.feature-recipe__ingredients').first(),
            title = document.title,
            button = $('<p />', {
                html : $('<a />', {
                    class : 'feature-print-button feature-recipe__print-button recipe__print-button',
                    href : 'javascript:void(0);',
                    html : '<i class="fa fa-print" aria-hidden="true"></i> Print Recipe'
                })
            });

        if(firstChild.is('h1,h2,h3,h4,h5,h6')) {
            //firstChild.after(button);
            recipe.data('title', firstChild.text());
        } else {
            //recipe.prepend(button);
        }

        button.insertBefore(ingredients);

        button.on('click', 'a', function(e) {
            var windowScroll = $(window).scrollTop(),
                root = $('html, body');

            e.preventDefault();

            root.css('scroll-behavior', 'auto');

            recipe.addClass('feature-being-printed');
            body.addClass('printing-feature');

            document.title = recipe.data('title') || title;

            window.print();

            setTimeout(function() {
                recipe.removeClass('feature-being-printed');
                body.removeClass('printing-feature');

                window.scrollTo({
                    top: windowScroll,
                    behavior: 'auto'
                });

                document.title = title;

                root.css('scroll-behavior', '');
            }, 25);
        });
    });
});

// PAW THROUGH ARTICLE CONTENT AND INJECT ADS AND RELATED STORIES
jQuery(function($) {
    if((typeof pageType === 'undefined') || (typeof pageLayout === 'undefined'))
        return;

    var parents = $('.story-content, .big-story .pw-section'),
        firstAdAfter = 200, // show the first ad this many px down per section
        relatedAfter = 450, // show related stories this many px down first section
        adSpread = 1.5,     // show an ad every 'n' windows
        adHeight = 250;

    if(cphGlobal.isSubscriber()) adSpread = 2.5;

    adSpread = $(window).height() * adSpread;

    var doRelatedStories = function() {
        // A 'relatedStories' variable will be printed in the Naviga Web output.
        // If present, this script will look for a place to put the element.

        if(pageType !== 'article' || pageLayout !== 'article')
            return;

        if((typeof relatedStories === 'undefined') || (typeof relatedStories.stories === 'undefined'))
            return;

        var rStories = relatedStories.stories;

        if(rStories.length) {
            var relatedParent = parents.length === 1 ? $(parents[0]) : $(parents[1]),
                parentOffset = relatedParent.offset().top,
                relatedChildren = relatedParent.find('> p:visible');

            var positionRelatedBlock = function(block) {
                var blockTop = block.offset().top,
                    blockBottom = blockTop + block.outerHeight();

                var i;
                for(i = 0; i < parents.length; i++) {
                    $(parents[i]).find('div.pd-shortcode-widget').each(function() {
                        var widget = $(this),
                            widgetOffset = widget.offset().top;

                        if(widgetOffset >= blockTop && widgetOffset <= blockBottom) {
                            widget.nextAll('p').first().before(block);
                            positionRelatedBlock(block);
                        }

                        if(widgetOffset > blockBottom) return false;
                    });
                }
            };

            var addRelatedBlock = function(child) {
                var relatedBlock = $('<div class="dynamic-content-block related-stories tpl2022__build-block tpl2022--overlay" data-path="relatedStories" data-template="story-list" data-heading="Related Stories" data-ref="related" data-max-stories="3"></div>');

                relatedBlock.insertBefore(child);

                relatedBlock.on('tpl:blockLoaded', function() {
                    positionRelatedBlock(relatedBlock);
                });

                smiBlock.get(relatedParent);

                return false;
            };

            relatedChildren.each(function(i) {
                var child = $(this),
                    childOffset = child.offset().top,
                    fromTop = Math.ceil(childOffset - parentOffset);

                if(child.is('p') && fromTop >= relatedAfter) {
                    addRelatedBlock(child);
                    return false;
                }

                // if not enough paragraphs, put related just before last paragraph
                if((i + 1) === relatedChildren.length) {
                    addRelatedBlock(child);
                    return false;
                }
            });
        }
    };

    var doPromoSlots = function() {
        // Promo slots are hard-coded in the Naviga Web output.
        // This script just moves them around to avoid collisions.

        var promoSlotIterator = function(promoSlot) {
            if(cphGlobal.hasFloatedObstacle(promoSlot)) {
                var next = promoSlot.next();
                if(next.length) {
                    if(next.is('.article-inline-promo')) {
                        next.remove();
                    } else {
                        promoSlot.insertAfter(next);
                    }
                    promoSlotIterator(promoSlot);
                }
            }
        };

        $('.article-inline-promo').each(function() {
            var promoSlot = $(this),
                inWidget = promoSlot.closest('.pd-shortcode-widget'),
                isBeforeFactbox = !!promoSlot.next().find('.fact-box').length;

            if(inWidget.length)
                promoSlot.insertAfter(inWidget);

            if(isBeforeFactbox)
                promoSlot.insertAfter(promoSlot.next());

            if(promoSlot.prev().is('.article-inline-promo')) {
                promoSlot.remove();
                return;
            }

            $(document).trigger('articleInlinePromo:loaded', promoSlot);

            promoSlotIterator(promoSlot);
        });
    };

    var doInlineAds = function() {
        if($('#inline-gallery-article').length) return;

        var inlineAd = $('<div/>', {class: 'article-inline-ad'}),
            videoAd = $('<div/>', {class: 'article-video-ad'}),
            dummyDiv = $('<div/>', {style: 'display: block; margin: 0; padding: 0; height: 0; overflow: hidden;'});

        var loadInlineAds = function() {
            var adDelay = 0;

            parents.find('.article-inline-ad, .article-video-ad').each(function(i) {
                var cube = $(this),
                    dataDevices = cube.data('devices'),
                    dataClass = cube.data('class'),
                    dataTargeting = cube.data('targeting'),
                    adClass = null, wrap, ad;

                adDelay = adDelay + 250;

                if(dataClass && dataClass !== 'undefined') {
                    adClass = dataClass;
                }

                if(cube.is('.article-video-ad')) {

                    wrap = smiDfp.buildAdWrapper('widget-centered', 'height: auto; width: 100%; max-width: 600px; margin-bottom: 1em;');

                    ad = smiDfp.buildAd('phone,tablet,desktop', adClass);
                    ad.addTargeting('location', 'sticky');
                    ad.addTargeting('type', 'article');
                    ad.addSize(600, 1);
                    ad.setNoReload();

                } else {

                    wrap = smiDfp.buildAdWrapper('widget-centered', 'height: 250px; width: 300px; background-color: #F0F0F0; box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.3);');

                    ad = smiDfp.buildAd('phone,tablet,desktop', adClass);
                    ad.addSize(300, 250);
                    ad.addTargeting('type', 'article');
                    ad.addTargeting('loc', i + 1);

                    // switched these 2023-01-31
                    ad.setShowOnScroll();
                    //ad.setDelay(adDelay);
                }

                if(dataTargeting && dataTargeting !== 'undefined') {
                    $.each(dataTargeting, function(key, value) {
                        ad.addTargeting(key, value);
                    });
                }

                ad.wrapWith(wrap);

                $(this).html(wrap);
            });

            smiDfp.loadAds(parents);
        };

        var inlineAdCount = 0;
        parents.each(function(i) {
            var block = $(this),
                blockWidth = Math.ceil(block.width()),
                blockSpread = Math.ceil(adSpread),
                blockOffset = Math.ceil(block.offset().top),
                children = block.find('> *'),
                page = i + 1,
                lastAdOffset = 0,
                firstAdAdded, adMarker, adMarkerOffset,
                dummy, dummyWidth;

            var resetMarkers = function() {
                adMarker = false;
                adMarkerOffset = false;
            };

            children.each(function() {
                var child = $(this);
                if(!child.is('p')) {
                    resetMarkers();
                    return; // continue;
                }

                var adReady = false;
                if(!child.prev().is('.article-inline-promo')) {
                    var childOffset = Math.ceil(child.offset().top) - blockOffset;
                    if(firstAdAdded) {
                        adReady = (childOffset - lastAdOffset) >= blockSpread;
                    } else {
                        adReady = childOffset >= firstAdAfter;
                    }
                }

                if(!adReady) return; // continue;

                if(!adMarker) {
                    adMarker = child;
                    adMarkerOffset = childOffset;

                    dummy = dummyDiv.clone().insertBefore(child);
                    dummyWidth = dummy.width();
                    dummy.remove();

                    if(dummyWidth !== blockWidth) {
                        resetMarkers();
                    }
                }

                if(!adMarker) return; // continue;

                var bottomOffset = Math.ceil(childOffset + child.height());
                if(bottomOffset < (adMarkerOffset + adHeight)) return; // continue;

                dummy = dummyDiv.clone().insertAfter(child);
                dummyWidth = dummy.width();
                dummy.remove();

                if(dummyWidth !== blockWidth) return; // continue;

                if(!firstAdAdded && page === 1 && ++inlineAdCount === 1) {
                    // This is the first ad block on the first page.
                    videoAd.clone().insertBefore(adMarker);
                } else {
                    inlineAd.clone().insertBefore(adMarker);
                }

                firstAdAdded = true;
                lastAdOffset = adMarkerOffset;
                resetMarkers();
            });
        });

        loadInlineAds();
    };

    doRelatedStories();

    // wait for related stories to populate
    setTimeout(function() {
        doPromoSlots();
    }, 500);

    // wait for related stories and promo slots to populate
    setTimeout(function() {
        doInlineAds();
    }, 1000);
});
// INIT CPH GALLERY FOR INLINE GALLERY ARTICLE TYPE
jQuery(function($) {
    let inlineGallery = $('#inline-gallery');

    if(!inlineGallery.length) return;

    cphLoader.loadCphGallery(function() {
        let loc = window.location,
            galleryHomeLink = siteConfig.url.base || (loc.protocol + '//' + loc.hostnamee),
            galleryLogoUrl = siteConfig.pub.logoWhite || null,
            galleryLogoAlt = siteConfig.pub.nameExt || null,
            galleryLogo = null;

        if(galleryLogoUrl) {
            galleryLogo = $('<a/>', {
                href : galleryHomeLink,
                html : $('<img/>', {
                    src : galleryLogoUrl,
                    alt : galleryLogoAlt,
                    style : 'max-width: 200px; height: auto;'
                })
            })
        }

        let cphGallery = $.cphGallery({
            logo: galleryLogo,

            banner: '<div id="cphGallery-banner-ad"></div><script>var cphGalWrap,cphGalAd;cphGalWrap=smiDfp.buildAdWrapper();cphGalAd=smiDfp.buildAd("phone");cphGalAd.addTargeting("position","ATF");cphGalAd.addSize(320,50);cphGalAd.setForceReload();cphGalAd.wrapWith(cphGalWrap);cphGalAd=smiDfp.buildAd("tablet");cphGalAd.addTargeting("position","ATF");cphGalAd.addSize(728, 90);cphGalAd.setForceReload();cphGalAd.wrapWith(cphGalWrap);$("#cphGallery-banner-ad").html(cphGalWrap);smiDfp.loadAds($("#cphGallery-banner-ad"));<\/script>',

            cube: '<div id="cphGallery-cube-ad" style="min-height: 250px; width: 300px; background: #EFEFEF;"><script>var cphGalCube=smiDfp.buildAd("desktop");cphGalCube.addTargeting("position","ATF");cphGalCube.addSize(300, 250);cphGalCube.setForceReload();$("#cphGallery-cube-ad").html(cphGalCube.render());smiDfp.loadAds($("#cphGallery-cube-ad"));<\/script>',

            headline: $('div.inline-gallery__title').text(),

            addUrlParam: 'gSlide',

            zIndex: 100000,

            on: {
                show       : function() {
                    $(document).on('onPaywallShown', function(e) {
                        console.log('onPaywallShown');
                        setTimeout(function() {
                            cphGallery.destroy();
                        }, 500);
                    });
                    if($('body').hasClass('has-pw')) {
                        setTimeout(function() {
                            cphGallery.destroy();
                        }, 500);
                    }

                    $('head').append('<style>.cph-gallery__footer-caption a{text-decoration:underline;}</style>');
                },
                slideChange: function() {
                    $(document).trigger('smi:gallerySlide');

                    if(typeof smiDfp.refreshAds === 'function') {
                        smiDfp.refreshAds();
                    } else {
                        console.log('DEBUG: function \'smiDfp.refreshAds\' is undefined');
                    }
                }
            }
        });

        $(document).on('dfpRendered', function(e, adSlot, origEvent) {
            if($(adSlot).closest('#cphGallery-banner-ad').length) {
                cphGallery.update();
            }
        });

        inlineGallery.find('.inline-gallery__hero-image').each(function() {
            let figure = $(this),
                img = figure.find('img');

            if(!img.length) return;

            let imgSrc = img.attr('data-src') || img.attr('src'),
                imgSrcset = img.attr('data-srcset') || img.attr('srcset'),
                imgAlt = img.attr('alt'),
                imgCaption = figure.find('figcaption').html(),
                imgId = cphGallery.md5(imgSrc);

            let button = cphGallery.getOpenIcon(imgId, null, 'inline-gallery__view-all');

            button.find('a').append('&nbsp;View<span id="cph-gallery-photo-count">&nbsp;</span>Photos');

            $('<div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; display: flex; align-items: center; justify-content: center;"></div>').html(button).insertAfter(img);

            cphGallery.addImageLazy(imgId, imgSrc, imgCaption, imgAlt, null, null, imgSrcset, '100vw');
        });

        let igCount = 0,
            igAdOuter, igAdWrap, igAd;

        inlineGallery.find('.inline-gallery__image').each(function() {
            let wrap = $(this),
                figure = $(this).find('> figure'),
                img = figure.find('img');

            if(!img.length) return;

            if((++igCount % 4) === 0) {
                igAdOuter = $('<div class="inline-gallery__ad"/>');

                igAdWrap = smiDfp.buildAdWrapper();

                igAd = smiDfp.buildAd('phone');
                igAd.addTargeting('position', 'big-gallery');
                igAd.addSize(320, 50);
                igAd.wrapWith(igAdWrap);

                igAd = smiDfp.buildAd('tablet,desktop');
                igAd.addTargeting('position', 'big-gallery');
                igAd.addSize(728, 90);
                igAd.wrapWith(igAdWrap);

                igAdOuter.html(igAdWrap);
                wrap.after(igAdOuter);
                smiDfp.loadAds(igAdOuter);
            }

            let imgSrc = img.attr('data-src') || img.attr('src'),
                imgSrcset = img.attr('data-srcset') || img.attr('srcset'),
                imgAlt = img.attr('alt'),
                imgCaption = figure.find('figcaption').html(),
                imgSubhead = wrap.find('> h3').text(),
                imgId = cphGallery.md5(imgSrc);

            img.after(cphGallery.getOpenIcon(imgId, null, 'inline-gallery__view-image'));

            cphGallery.addImageLazy(imgId, imgSrc, imgCaption, imgAlt, imgSubhead, null, imgSrcset, '100vw');
        });

        $('#cph-gallery-photo-count').html('&nbsp;' + cphGallery.slides.length + '&nbsp;');

        cphGallery.ready();
    });
});

/**
 * Sad Puppy Slide In
 */
/*jQuery(function($) {
    if(window.pageType !== 'article') return;

    if(!window.pageSections || !pageSections.length) return;

    if(!cphGlobal.hasLocalStorage()) return;

    var prefs = 'alert,daily';
    if(cphPD) prefs = 'alert,daily,evening';

    var config = {
        email      : null,
        lastShown  : null,
        promos     : {
            sadPuppy     : {
                name        : 'Sad Puppy',
                sections    : ['news'],
                src         : cphNlHost + '/widget/sad-puppy/prefs:' + prefs + '/script.js',
                lastShown   : null,
                subscribedOn: null
            }
        }
    };

    var configStored = JSON.parse(localStorage.getItem('nlPromoConfig') || '{}');

    config = {...config, ...configStored};

    var forceShow = cphGlobal.getQueryStringValueByKey('forceNlPromo'),
        showPromo = null;

    if(forceShow) {

        console.log('PRM: Forcing promo \'' + forceShow + '\'');
        console.log('PRM: config:', config);
        showPromo = config.promos[forceShow] || null;
        if(showPromo) {
            console.log('PRM: promo:', showPromo);
        } else {
            console.log('PRM: Promo \'' + forceShow + '\' does not exist');
        }

    } else {

        if(config.lastShown) {
            // stop if any ad was last shown today (or in the future)
            var lastShownOn = cphGlobal.dateYMD(config.lastShown),
                today = cphGlobal.dateYMD(Date.now());
            if(lastShownOn >= today) return;
        }

        // Iterate through promos to remove those that are subscribed to or shown in 3 days
        var availablePromos = [],
            threeDaysInMS = 60 * 60 * 24 * 3 * 1000;
        $.each(config.promos, function(i, promo) {
            if(promo.subscribedOn) return;
            if(promo.lastShown) {
                var nextShowOn = cphGlobal.dateYMD(promo.lastShown + threeDaysInMS),
                    today = cphGlobal.dateYMD(Date.now());
                if(today < nextShowOn) return;
            }
            availablePromos.push(promo);
        });

        // Match available promos to current section and return first available match
        $.each(availablePromos, function(i, promo) {
            var sectionMatch = promo.sections.some(n => window.pageSections.some(h => h === n));
            if(sectionMatch) {
                showPromo = promo;
                return false; // to break out of loop
            }
        });

    }

    if(!showPromo) return;

    $(document).one('scroll50', function(e) {
        if(forceShow) console.log('PRM: Showing promo \'' + showPromo.name + '\'');
        if(!forceShow && $(document.body).hasClass('circ-subscribed')) return;

        $('<script/>', {
            src : showPromo.src
        }).appendTo(document.body);

        config.lastShown = Date.now();
        showPromo.lastShown = Date.now();

        localStorage.setItem('nlPromoConfig', JSON.stringify(config));

        window.addEventListener('message', function(event) {
            var data = event.data;
            if(data.message === 'smiNewsletterSubscribeSuccess') {
                if(forceShow) console.log('PRM: subscribed:', data);

                config.email = data.email;
                showPromo.subscribedOn = Date.now();
                localStorage.setItem('nlPromoConfig', JSON.stringify(config));

                if(forceShow) console.log('PRM: config:', config);
            }
        }, false);
    });
});*/

jQuery(function($) {
    $(document).on('mg2:notSubscribed mg2:loggedOut', function() {
        const insertAfter = $('.nativo_art:first');
        let divId, widgetId;

        if(!insertAfter.length || insertAfter.data('revcontent-placed')) return;

        if(cphPD) {
            divId = 'rc-widget-9c7cb7';
            widgetId = '281026';
        } else if(cphSIT) {
            divId = 'rc-widget-c85dc5';
            widgetId = '281102';
        } else if(cphPAC) {
            divId = 'rc-widget-6e3825';
            widgetId = '281103';
        } else if(cphNBBJ) {
            divId = 'rc-widget-b8f2f0';
            widgetId = '281104';
        }

        if(!divId || !widgetId) return;

        insertAfter.after('<div id="' + divId + '" data-rc-widget data-widget-host="habitat" data-endpoint="//trends.revcontent.com" data-widget-id="' + widgetId + '" style="margin: 1em auto;"></div>');

        insertAfter.data('revcontent-placed', true);

        $.getScript('https://assets.revcontent.com/master/delivery.js');
    });
});
jQuery(function($) {
    var scrollContainer = $('article.article-container');

    if(!scrollContainer.length) return;

    var imageContainer = scrollContainer.find('.main-gallery, .big-story-cover, #recipe-cover'),
        scroll0, scroll25, scroll50, scroll75, scroll100;

    function scrollPositionTrigger() {
        var scrollPosition = $(window).scrollTop(),
            articleBottom = scrollContainer.offset().top - $(window).height(),
            imageHeight = imageContainer.height(),
            scrollOffset = scrollPosition - (articleBottom + imageHeight),
            quarterHeight = (scrollContainer.height() - imageHeight) / 4;

        if(!scroll0 && scrollOffset > 0) {
            scroll0 = true;
            $(document).trigger('scroll0');
        } else if(!scroll25 && scrollOffset > quarterHeight) {
            scroll25 = true;
            $(document).trigger('scroll25');
        } else if(!scroll50 && scrollOffset > (2 * quarterHeight)) {
            scroll50 = true;
            $(document).trigger('scroll50');
        } else if(!scroll75 && scrollOffset > (3 * quarterHeight)) {
            scroll75 = true;
            $(document).trigger('scroll75');
        } else if(!scroll100 && scrollOffset > (4 * quarterHeight)) {
            scroll100 = true;
            $(document).trigger('scroll100');
        }
    }

    cphLoader.loadThrottleDebounce(function() {
        $(window).on('scroll.scrollPositionTrigger', $.throttle(1000, function() {
            if(!(scroll0 && scroll25 && scroll50 && scroll75 && scroll100)) {
                scrollPositionTrigger();
            } else {
                $(window).off('scroll.scrollPositionTrigger');
            }
        }));
    });
});

// RESIZE SPLIT IMAGES TO FORCE SAME HEIGHT IN [imageByName:] SHORTCODE
jQuery(function($) {
    $('.pd-widget-position-split').each(function() {
        var split = $(this),
            images = split.find('img'),
            imageNum, aspect, smallerAspect;

        if(images.length === 2) {
            imageNum = 1;
            $.each(images, function() {
                $(this).on('load', function() {
                    aspect = Math.round(($(this).height() / $(this).width()) * 100);

                    if(!smallerAspect || aspect < smallerAspect) {
                        smallerAspect = aspect;
                    }

                    if(imageNum++ === 2) {
                        split.addClass('resized').find('.pd-figure-outer-wrap').css({paddingBottom: smallerAspect + '%'});
                    }
                });
            });
        }
    });
});
// BUILD SWIPER GALLERY BASED ON 'VAR mainGallery' or [gallery:] SHORTCODE
jQuery(function($) {
    var inlineGalleries = $('.smi-inline-gallery'),
        refreshAdsEach = window['refreshAdsEach'] === 'undefined' ? 2 : window['refreshAdsEach'],
        injectAdEvery = 0,
        refreshCounter = 0;

    injectAdEvery = 6; // inject ad after every (n)th slide

    if(typeof mainGallery !== 'undefined' && $.isArray(mainGallery.images)) {
        cphLoader.loadSwiper(function() {
            printGallery($('#main-gallery-container'), mainGallery, true);
        });
    }

    if(inlineGalleries.length) {
        cphLoader.loadSwiper(function() {
            $.each(inlineGalleries, function() {
                var placeholder = $(this),
                    isInline = placeholder.data('image-json'),
                    isByUUID = placeholder.data('uuid'),
                    pWidth = placeholder.width();

                if(isInline && (typeof window[isInline] !== 'undefined')) {
                    printGallery(placeholder, window[isInline]);
                } else if(isByUUID) {
                    var imageSize = 'large';
                    if(typeof window.imageSizes !== 'undefined' && !$.isEmptyObject(window.imageSizes)) {
                        $.each(window.imageSizes, function(size, px) {
                            if(pWidth < px) {
                                imageSize = size;
                                return false;
                            }
                        });
                    }

                    $.getJSON('/smi/feeds/json/images/?uuid=' + isByUUID + '&size=' + imageSize).done(function(data) {
                        printGallery(placeholder, data);
                    });
                }
            });
        });
    }

    function printGallery(placeholder, data, isMainGallery) {
        var galleryOuter = $('<div />', {'class': 'swiper-gallery', 'style': 'overflow: hidden;'}),
            swiperContainer = $('<div />', {'class': 'swiper-container'}),
            swiperWrapper = $('<div />', {'class': 'swiper-wrapper'}),
            captionContainer = $('<div />', {'class': 'cph-gallery-captions'}),
            slideCount = data.images.length,
            gallerySize = placeholder.data('size'),
            galleryPosition = placeholder.data('position'),
            tsmSlide;

        if(placeholder.parent().is('p'))
            placeholder.unwrap();

        if(!gallerySize)
            gallerySize = 'medium';

        if(!galleryPosition)
            galleryPosition = 'full';

        //if(slideCount > 1)
        //tsmSlide = insertGalleryTopStories();

        if(tsmSlide)
            slideCount = slideCount + 1;

        $.each(data.images, function(i, v) {
            var isLastSlide = data.images.length === (i + 1),
                theContent, theCaption, theAltText;

            if(v.video.embed.length > 3) {
                // v.video.embedap for autoplay version
                theContent = '<iframe class="gallery-video" src="" data-src="' + v.video.embed + '" border="0" scrolling="no" allowfullscreen></iframe>';
                theCaption = v.video.caption.length > 3 ? v.video.caption : null;
            } else {
                theCaption = v.image.caption.length > 3 ? v.image.caption : null;
                theAltText = theCaption ? theCaption : 'slide image';
                theAltText = $('<div/>', {
                    html: theAltText
                }).text();

                var imgTag = $('<img/>', {
                    alt: theAltText
                });
                if(isMainGallery && i === 0) {
                    imgTag.attr('src', v.image.href);
                    theContent = imgTag[0];
                } else {
                    imgTag.addClass('swiper-lazy').attr('data-src', v.image.href);
                    theContent = $('<div/>').html([imgTag, $('<div class="swiper-lazy-preloader swiper-lazy-preloader-white"/>')]).html();
                }
            }

            buildGallerySlide(i, theContent, theCaption);

            if(!isLastSlide && isMainGallery && injectAdEvery && $(window).width() > 767 && !$(document.body).is('.ad-lite, .ad-free')) {
                if(i > 0 && (i % injectAdEvery) === 0 && i < data.images.length) {
                    var slideAd = smiDfp.buildAd('phone,tablet,desktop', 'gallery-ad');
                    slideAd.addSize(300, 250);
                    slideAd.setDeferred();

                    theContent = slideAd.render();
                    theCaption = 'Advertisement';

                    buildGallerySlide(i + 'a', theContent, theCaption);
                }
            }
        });

        if(tsmSlide)
            buildGallerySlide((slideCount - 1), tsmSlide, null);

        function insertGalleryTopStories() {
            if(typeof mainGalleryTSM !== 'undefined') {
                if($.isPlainObject(mainGalleryTSM) && mainGalleryTSM.stories.length >= 12) {
                    var thisSlide = $('<div />', {
                        class: 'gallery-tsm-slide',
                        html : $('<h3 />', {text: 'More from The ' + cphPubName})
                    });

                    var contentDiv = $('<div />', {
                        class: 'gallery-tsm-slide-content'
                    });

                    $.each(mainGalleryTSM.stories, function(i, sty) {
                        var storyDiv = $('<div />', {class: 'gallery-tsm-item'}),
                            innerDiv = $('<a />', {
                                class: 'gallery-tsm-item-inner',
                                href : cphGlobal.updateQueryStringParameter('ref', 'GAL', sty.href),
                                html : $('<div />', {
                                    class: 'gallery-tsm-item-gradient'
                                })
                            }),
                            imgDiv = $('<div />', {
                                class: 'gallery-tsm-image-sizer',
                                html : $('<div />', {
                                    class: 'gallery-tsm-image-holder',
                                    html : $('<img />', {src: sty.image.thumb, alt: 'slide recent image'})
                                })
                            }),
                            headline = $('<div />', {class: 'gallery-tsm-title', text: sty.headline});

                        innerDiv.append(imgDiv);
                        innerDiv.append(headline);
                        storyDiv.html(innerDiv);

                        contentDiv.append(storyDiv);
                    });

                    thisSlide.append(contentDiv);

                    return thisSlide;
                }
            }
            return false;
        }

        function buildGallerySlide(slideNum, content, caption) {
            var slideWrapper = $('<div />', {
                'class': 'swiper-slide',
                html   : $('<div />', {'class': 'cph-gallery-container', html: content})
            }).attr('data-caption-id', slideNum).attr('data-art-slide', slideNum);

            var captionWrapper = $('<div />', {'class': 'cph-gallery-caption'}).attr('data-caption-id', slideNum);

            if(slideCount > 1 && $.isNumeric(slideNum)) {
                $('<div />', {
                    'class': 'cph-gallery-slide-count',
                    html   : $('<strong />', {text: 'Slide ' + (slideNum + 1) + ' of ' + slideCount})
                }).appendTo(captionWrapper);
            }

            if(caption) {
                $('<div />', {html: caption}).appendTo(captionWrapper);
            }

            swiperWrapper.append(slideWrapper);
            captionContainer.append(captionWrapper);
        }

        swiperContainer.html(swiperWrapper).append('<div class="swiper-button-next swiper-button-white"></div> <div class="swiper-button-prev swiper-button-white"></div>');

        galleryOuter.html(swiperContainer).append(captionContainer);

        if(!isMainGallery) {
            galleryOuter = cphGlobal.wrapFigures(cphGlobal.wrapWithFigure(galleryOuter), gallerySize, galleryPosition);
        }

        placeholder.replaceWith(galleryOuter);

        initGallery(galleryOuter, isMainGallery);
    }

    function initGallery(gallery, isMainGallery) {
        var swiperContainer = gallery.find('.swiper-container'),
            swiperSlides = swiperContainer.find('.swiper-slide'),
            swiperPrev = swiperContainer.find('.swiper-button-prev'),
            swiperNext = swiperContainer.find('.swiper-button-next'),
            isSingle = swiperSlides.length < 2,
            initialSlide = parseInt(cphGlobal.getQueryStringValueByKey('artslide')),
            firstTransitionSkipped = false;

        initialSlide = (isMainGallery && !isSingle && !isNaN(initialSlide)) ? initialSlide : 0;

        if(isSingle) {
            swiperPrev.add(swiperNext).remove();
            gallery.addClass('is-single-slide');
        } else {
            swiperPrev.add(swiperNext).show();
        }

        new Swiper(swiperContainer[0], {
            navigation        : {
                prevEl: isSingle ? null : swiperPrev[0],
                nextEl: isSingle ? null : swiperNext[0]
            },
            initialSlide      : initialSlide,
            simulateTouch     : !isSingle,
            threshold         : 10,
            grabCursor        : !isSingle,
            loop              : !isSingle,
            preloadImages     : false,
            lazy              : {
                loadPrevNext: true
            },
            runCallbacksOnInit: !isSingle,
            on                : {
                init                      : function() {
                    setSwiperHeight();
                    if(isSingle) doOnTransitionStart(this);
                },
                resize                    : function() {
                    setSwiperHeight();
                },
                slideChangeTransitionStart: function() {
                    doOnTransitionStart(this);
                },
                slideChangeTransitionEnd  : function() {
                    doAfterSlideChange(this);
                }
            }
        });

        function setSwiperHeight() {
            var outerHeight = Math.floor(swiperContainer.width() * 0.75);
            var maxHeight = Math.floor($(window).height() * 0.8);
            outerHeight = (maxHeight < outerHeight) ? maxHeight : outerHeight;

            swiperContainer.css({height: outerHeight + 'px'});
            swiperContainer.find('.cph-gallery-container').css({
                height    : outerHeight + 'px',
                lineHeight: (outerHeight - 4) + 'px'
            });
        }

        function doOnTransitionStart(swiper) {
            var activeSlide = $(swiper.slides[swiper.activeIndex]),
                activeSlideCaptionId = activeSlide.data('caption-id'),
                activeCaption;

            gallery.find('.cph-gallery-caption').hide();
            if(activeSlideCaptionId !== 'undefined') {
                activeCaption = gallery.find('.cph-gallery-caption[data-caption-id=' + activeSlideCaptionId + ']');
                if(activeCaption.length && activeCaption.text().length) {
                    activeCaption.show();
                }
            }

            swiperSlides.find('iframe').attr('src', '');
            activeSlide.find('iframe').each(function() {
                $(this).attr('src', $(this).data('src'));
            });
        }

        function doAfterSlideChange(swiper) {
            var activeSlide = $(swiper.slides[swiper.activeIndex]),
                slideIndex = activeSlide.data('art-slide');

            if(activeSlide.find('.gallery-ad').length) {
                smiDfp.loadDeferredAds(activeSlide);
            }

            if(firstTransitionSkipped) {

                if(isMainGallery) {
                    var newUrl = window.location.href;
                    newUrl = cphGlobal.removeUTM(newUrl);
                    newUrl = cphGlobal.updateQueryStringParameter('ref', false, newUrl);
                    newUrl = cphGlobal.updateQueryStringParameter('slide', false, newUrl);
                    newUrl = cphGlobal.updateQueryStringParameter('artslide', slideIndex, newUrl);

                    // adding param to last slide if it is a gallery slide
                    if(activeSlide.find('.gallery-tsm-slide').length) {
                        newUrl = cphGlobal.updateQueryStringParameter('slide', 'GAL', newUrl);
                    }

                    cphGlobal.replaceUrl(newUrl);
                }

                $(document).trigger('smi:gallerySlide');

                refreshCounter = refreshCounter + 1;
                if(refreshCounter >= refreshAdsEach) {
                    refreshCounter = 0;

                    if(typeof smiDfp.refreshAds !== 'undefined' && $.isFunction(smiDfp.refreshAds)) {
                        smiDfp.refreshAds();
                    } else {
                        console.log('DEBUG: function \'smiDfp.refreshAds\' is undefined');
                    }
                }
            }
            firstTransitionSkipped = true;
        }
    }
});